import config from "../config";
import { serviceInstance } from "../axiosInterceptor/requestHandler";

const orderService = {
  fecthCountries: () =>
    serviceInstance
      .get(`${config.baseurl}/Utility/Countries`)
      .then(({ data, status }) => {
        return data;
      }),
  fecthCountriesStates: (id) =>
    serviceInstance
      .get(`${config.baseurl}/Utility/StatesByCountry/${id}`)
      .then(({ data, status }) => ({
        ...data,
      })),
  fetchBusinessTransactions: (id) =>
    serviceInstance
      .get(`${config.baseurl}/DepotProductOrder/Payments/${id}`)
      .then(({ data, status }) => {
        return data;
      }),
};

export default orderService;
